import React from 'react'
import styles from './RowLevel.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { permissions } from 'settings/permissions'
import useLocalization from 'hooks/useLocalization'

const RowLevel = ({ action, index, activity }) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'lvls',
    dict: {
      level_name: 'Level name',
      min_lessons_required:
        'Minimum number of lessons required to obtain this level',
      edit: 'Edit',
      delete: 'Delete',
      enter_name: 'Enter the name',
      edit_level: 'Edit level',
      are_you_sure: 'Are you sure',
      are_you_sure_delete_level: 'Are you sure you want to delete the level',
    },
  })

  const menu = [
    {
      name: translate.edit,
      action: 'edit',
      permission: permissions.change_levelcondition,
    },
    {
      name: translate.delete,
      action: 'delete',
      permission: permissions.delete_levelcondition,
    },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''}`}
      >
        <div className={styles.containerInf}>
          <div className={`${styles.infStyl} ${styles.name}`}>
            <div>
              {translate.level_name}: <span>{activity.name}</span>
            </div>
            <div>
              {translate.min_lessons_required}:{' '}
              <span>{activity.finished_lessons_count}</span>
            </div>
          </div>
          <div className={styles.buttons}>
            <ActionMenu menu={menu} action={action} items={activity} />
          </div>
        </div>
      </div>
    </>
  )
}

export default RowLevel
